<template>
  <div class="stk-select">
    <select
      :value="modelValue ?? value"
      @change="handleChange"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <Icon />
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import Icon from '../../graphic/icon/Icon.vue';

const props = defineProps({
  value: String,
  modelValue: String,
  options: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['input', 'update:modelValue']);

const handleChange = event => {
  const newValue = event.target.value;

  // Emit the standard v-model event
  emit('input', newValue); // Vue 2
  emit('update:modelValue', newValue); // Vue 3
  emit('change', newValue);
};
</script>
